import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

/* eslint-env browser */
import { calculateItemWidth } from '../helpers';
import { useDeviceType, useSwipe } from '../../../hooks';

var useCarouselSwipe = function useCarouselSwipe(_ref) {
  var disabled = _ref.disabled,
      disableSwipe = _ref.disableSwipe,
      disableScrollOnTouch = _ref.disableScrollOnTouch,
      _ref$withNoEventsProp = _ref.withNoEventsPropagation,
      withNoEventsPropagation = _ref$withNoEventsProp === void 0 ? false : _ref$withNoEventsProp,
      _ref$withClickPrevent = _ref.withClickPrevention,
      withClickPrevention = _ref$withClickPrevent === void 0 ? true : _ref$withClickPrevent,
      props = _objectWithoutPropertiesLoose(_ref, ["disabled", "disableSwipe", "disableScrollOnTouch", "withNoEventsPropagation", "withClickPrevention"]);

  var translateXMultiplier = props.translateXMultiplier;

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  var onEnd = function onEnd(e, _ref2) {
    var touchRelativeX = _ref2.x;
    var containerWidth = props.containerWidth,
        numberOfCards = props.numberOfCards,
        onActiveItemIndexChange = props.onActiveItemIndexChange,
        activeItemIndex = props.activeItemIndex,
        threshold = props.threshold,
        items = props.items,
        translateXMultiplier = props.translateXMultiplier;
    var itemWidth = calculateItemWidth({
      containerWidth: containerWidth,
      numberOfCards: numberOfCards
    });
    var noOfItemsToSwipe = Math.floor(Math.abs(touchRelativeX * translateXMultiplier) / itemWidth + (1 - threshold));

    if (noOfItemsToSwipe > 0) {
      var newActiveItemIndex = Math.min(Math.max(touchRelativeX * translateXMultiplier < 0 ? activeItemIndex - noOfItemsToSwipe : activeItemIndex + noOfItemsToSwipe, 0), items.length - 1);

      if (newActiveItemIndex !== activeItemIndex) {
        onActiveItemIndexChange(newActiveItemIndex);
      }
    }
  };

  var _useSwipe = useSwipe(null, onEnd, null, hasTouchScreen, disabled || disableSwipe, withNoEventsPropagation, false, withClickPrevention, disableScrollOnTouch ? false : 'auto'),
      setRef = _useSwipe.setRef,
      offsetPosition = _useSwipe.offsetPosition;

  return {
    setSwipeRef: setRef,
    touchRelativeX: offsetPosition.x * translateXMultiplier
  };
};

export default useCarouselSwipe;